export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6598.3861fc1d.jpg";